/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type HideReviewedFilterSchemaBy = typeof HideReviewedFilterSchemaBy[keyof typeof HideReviewedFilterSchemaBy];


export const HideReviewedFilterSchemaBy = {
  anyone: 'anyone',
  me: 'me',
} as const;
